export default "__VITE_ASSET__Dl9HV4TX__"